import {
  chainDynamicValue,
  DynamicValue,
  useComponentState,
} from "@faedev/dynamic-values";
import { composeClassNames } from "@faedev/editor-utils";
import {
  Accordion,
  AccordionCollapse,
  AccordionToggle,
  Alert,
  Card,
  Col,
  Form,
} from "react-bootstrap";
import FormJoinUsClass from "src/components/FormJoinUsClass";
import Heading from "src/components/Heading";
import Paragraph from "src/components/Paragraph";
import Text from "src/components/Text";
import Translate from "src/components/Translate";
import gutter from "src/functions/gutter";
import onChangeToValueCheckbox from "src/functions/onChangeToValueCheckbox";
import { sAlert } from "src/styles/sAlert.module.scss";
import { sFormAccordion } from "src/styles/sFormAccordion.module.scss";
import { sFormControl } from "src/styles/sFormControl.module.scss";
import { sFormLabel } from "src/styles/sFormLabel.module.scss";
import { DataJoinUsForm } from "src/types/DataJoinUsForm";

type Props = { formData: DynamicValue<DataJoinUsForm> };

function FormJoinUsClasses({ formData }: Props) {
  var toggleAccordion = useComponentState(false);
  return (
    <Accordion
      defaultActiveKey={`1`}
      className={composeClassNames([sFormAccordion, "joinus-classes"])}
    >
      <Card>
        <AccordionToggle eventKey={`0`}>
          <Heading
            type={`h2`}
            title={
              <>
                {`7. `}
                <Translate tKey={`Content`} />
                <Text size={`md`} width={`regular`}>
                  {`4 `}
                  <Translate tKey={`min.`} />
                </Text>
              </>
            }
          />
        </AccordionToggle>
        <AccordionCollapse eventKey={`0`}>
          <Card.Body>
            <Heading type={`h4`} title={<Translate tKey={`Paid content`} />} />
            <Alert variant={`primary`} className={sAlert}>
              <Form.Row>
                <Col sm={8} xs={12}>
                  <Form.Check id={`content-paid`} name={`content-paid`}>
                    <Form.Check.Input
                      className={sFormControl}
                      name={`content-paid`}
                      onChange={function (param2) {
                        return chainDynamicValue(
                          formData,
                          "content-paid"
                        ).change(onChangeToValueCheckbox(param2));
                      }}
                      value={chainDynamicValue(formData, "content-paid").value}
                    />
                    <Form.Check.Label className={sFormLabel}>
                      <Translate
                        tKey={`I want to sell my videos, streamed/live classes, books or any other content.`}
                      />
                    </Form.Check.Label>
                  </Form.Check>
                  <Paragraph size={`xn`}>
                    <Translate
                      tKey={`If you check this option, our colleague will contact you, who will talk to you about the details of the correct sales settings.`}
                    />
                  </Paragraph>
                </Col>
              </Form.Row>
            </Alert>
            <Heading type={`h4`} title={<Translate tKey={`Free content`} />} />
            <Paragraph size={`md`} style={gutter(`margin`, `vertical`, `0`)}>
              <Translate
                tKey={`Each profile can have a maximum of two free classes, with a video length of up to 20 minutes. Now it doesn't matter that they are longer, but later they will be automatically cropped.`}
              />
            </Paragraph>
            <FormJoinUsClass
              key={1}
              item={1}
              formDataClassTitle={chainDynamicValue(formData, "class-title-1")}
              formDataClassFocus={chainDynamicValue(formData, "class-focus-1")}
              formDataClassDifficulty={chainDynamicValue(
                formData,
                "class-difficulty-1"
              )}
              formDataClassShortDescription={chainDynamicValue(
                formData,
                "class-short-description-1"
              )}
              formDataClassVideo={chainDynamicValue(formData, "class-video-1")}
            />
            <FormJoinUsClass
              key={2}
              item={2}
              formDataClassTitle={chainDynamicValue(formData, "class-title-2")}
              formDataClassFocus={chainDynamicValue(formData, "class-focus-2")}
              formDataClassDifficulty={chainDynamicValue(
                formData,
                "class-difficulty-2"
              )}
              formDataClassShortDescription={chainDynamicValue(
                formData,
                "class-short-description-2"
              )}
              formDataClassVideo={chainDynamicValue(formData, "class-video-2")}
            />
          </Card.Body>
        </AccordionCollapse>
      </Card>
    </Accordion>
  );
}

export default FormJoinUsClasses;
